import { Chip } from "@mui/material";
import React, { useMemo,memo } from "react";
import GaugeChart from "react-gauge-chart";

const cardContent = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  color: "#d3f4fe",
  minWidth: "50px",
  gap: "4px",
  fontSize: "15px",
  fontWeight: 500,
};

const chipStyle = {
  color: "#d3f4fe",
  minWidth: "50px",
};

const EntryExitKPI = memo(({ avgInOut, avgIn, avgOut }) => {
  const percentage = useMemo(() => {
    if (avgInOut < 0.5) return 0.2;
    if (avgInOut >= 0.5 && avgInOut < 0.8) return 0.5;
    if (avgInOut >= 0.8) return 0.8;

    return 0.2;
  }, [avgInOut]);
  return (
    <div className="d-flex flex-column justify-content-center align-items-center">
      {/* <GaugeChart
        id="gauge-chart4"
        animate={false}
        colors={["#f00", "#ffff00","lawngreen"]}
        arcPadding={0.1}
        cornerRadius={4}
        percent={percentage}
        hideText="true"
        style={{ width: "110px" }}
        className="dashboard-health-title"
      /> */}
      {/* <span>{avgInOut!=='N/A'&&avgInOut.toFixed(1)}</span> */}
      <div className="card-value">Avg.Entry Exit</div>
      <img src="/images/icons/entry_exit_icon.png" alt="" width={60} />
      <div className="d-flex flex-column justify-content-start align-items-start gap-2">
        <div className="d-flex justify-content-center align-items-center card-value">
          <Chip label="Max. In" sx={chipStyle} />
          <p className="m-1 p-0">{avgIn}</p>
        </div>
        <div className="d-flex justify-content-center card-value">
          <Chip label="Max. Out" sx={chipStyle} />
          <p className="m-1 p-0">{avgOut}</p>
        </div>
      </div>
    </div>
  );
});

export default EntryExitKPI;
